var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3061 0.919922C7.63786 0.919922 2.79716 4.44558 0.835938 9.42232C2.79716 14.3991 7.63786 17.9247 13.3061 17.9247C18.9744 17.9247 23.8151 14.3991 25.7763 9.42232C23.8151 4.44558 18.9744 0.919922 13.3061 0.919922ZM13.3061 15.0906C10.1772 15.0906 7.63786 12.5512 7.63786 9.42232C7.63786 6.29344 10.1772 3.75405 13.3061 3.75405C16.435 3.75405 18.9744 6.29344 18.9744 9.42232C18.9744 12.5512 16.435 15.0906 13.3061 15.0906ZM13.3061 6.02136C11.4243 6.02136 9.90516 7.54046 9.90516 9.42232C9.90516 11.3042 11.4243 12.8233 13.3061 12.8233C15.188 12.8233 16.7071 11.3042 16.7071 9.42232C16.7071 7.54046 15.188 6.02136 13.3061 6.02136Z",
    fill: "#ED1010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.931edcf4ffd2dbccced71b335b73623b.svg";
export { ForwardRef as ReactComponent };